import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { MessageComponent } from './Message.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgxJsonViewerModule
  ],
  exports: [
    MessageComponent
  ],
  declarations: [
    MessageComponent
  ],
})

export class MessageModule {

}
